<template>
  <div class="animated fadeIn">
    <h4 class="page-title">Servicing Overview</h4>
    <hr >
    <b-row>
      <b-col>
        <b-btn
          size="sm"
          variant="success"
          class="mb-3 float-right"
          @click="handleDownload">
          <i class="fa fa-download" />&nbsp;
          Download
        </b-btn>
        <b-table
          :items="servicingOverview"
          :fields="servicingOverviewFields"
          :sort-by="sortBy"
          :sort-desc="sortDesc"
          striped
          responsive>
          <template v-slot:head(sn)>
            <span>S/N</span>
          </template>
          <!-- A virtual column -->
          <template #cell(sn)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(nextServiceDate)="{ item }">
            <span>{{ item.nextServiceDate | date('DD/MM/YYYY') }}</span>
          </template>
          <template v-slot:cell(lastServiceDate)="{ item }">
            <span>{{ item.lastServiceDate | date('DD/MM/YYYY') }}</span>
          </template>
          <template v-slot:cell(vehicleBatteryChangeDate)="{ item }">
            <span>{{ item.vehicleBatteryChangeDate | date('DD/MM/YYYY') }}</span>
          </template>
          <template v-slot:cell(keyBatteryChangeDate)="{ item }">
            <span>{{ item.keyBatteryChangeDate | date('DD/MM/YYYY') }}</span>
          </template>
          <template v-slot:cell(lastServiceMileage)="{ item }">
            <span>{{ item.lastServiceMileage > -1 ? item.lastServiceMileage : 0 }}</span>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'ServicingOverview',
  data () {
    return {
      sortBy: 'lastServiceDate',
      sortDesc: true,
    }
  },
  computed: {
    ...mapState('mrs', [
      'servicingOverview',
      'servicingOverviewFields'
    ])
  },
  created() {
    this.$store.dispatch('mrs/getServicingOverview')
  },
  methods: {
    handleDownload() {
      try {
        const arr = JSON.parse(JSON.stringify(this.servicingOverview))
        const headers = Object.keys(arr[0])
        const replacer = (key, value) => value === null ? '' : value
        let csvData = arr.map(row => headers.map(fieldName => JSON.stringify(this.formatField(fieldName, row[fieldName]), replacer)).join(','))
        csvData.unshift(headers.join(','))
        csvData = csvData.join('\r\n')
        const filename = `SERVICING_OVERVIEW_${this.$options.filters.date(new Date(), 'YYYY-MM-DD')}.csv`
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' })
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, filename)
        } else {
          const link = document.createElement('a')
          if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', filename)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    formatField(key, value) {
      if (['nextServiceDate','lastServiceDate', 'vehicleBatteryChangeDate', 'keyBatteryChangeDate'].includes(key)) {
        return this.$options.filters.date(value, 'DD/MM/YYYY')
      }
      if (key === 'lastServiceMileage') {
        return value > -1 ? value : 0
      }
      return value
    }
  }
}
</script>